import { Col, Row, Space, Button, DatePicker as AntdDatePicker, Flex } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { DatePicker, Input, RadioGroup, Select, TimePicker } from "components/form";
import styles from "../styles/MyRequestFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";
import ApproveStatusOption from "components/elements/Select/ApproveStatusDropdown";
import RangePicker from "components/form/DatePicker/RangePicker";
import { FormInput, FormSelect } from "components/form/FormProvide";
import moment from "moment";

const MyRequestFilter = ({
  initialValues = {},
  dataFlag = null,
  leaveGroupOptions = [],
  OffSiteOptions = [],
  documentTypeOptions = [],
  employeeOptions = [],
  dropdownWelfareSubTypeByCode = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const leaveDatePickerRef = useRef(null);
  const overtimeDatePickerRef = useRef(null);

  const { modifiedStatus = [] } = ApproveStatusOption()
  const startTime = "00:00:00"
  const endTime = "00:00:00"

  const shiftTypeOptions = [
    { value: '', key: "ALL" },
    { value: 'SWAP', key: "SWAP" },
    { value: 'CHANGE', key: "CHANGE" },
  ];

  return (

    <Formik
      initialValues={{
        ...initialValues,
        leaveDate: null,
        overtimeDate: null,
      }}
      onSubmit={(values) => {
        console.log("🚀 ~ values:", values)
        onSearch({
          ...values,
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        const handleReset = () => {
          if (leaveDatePickerRef.current) {
            leaveDatePickerRef.current.blur();
            setFieldValue('leaveDate', null);
          }
          if (overtimeDatePickerRef.current) {
            overtimeDatePickerRef.current.blur();
            setFieldValue('overtimeDate', null);
          }
          resetForm();
        };
        return (
          <Form>
            {dataFlag == "LEAVE" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="reqId"
                    label={t('workin_location.label.reqid')}
                    placeholder={t('workin_location.label.reqid')}
                    size="large"
                  />
                </Col>
                {/* <Col span={8}>
                  <Input
                    name="name"
                    label={t('employee.label.employee-name')}
                    placeholder={t('employee.label.employee-name')}
                    size="large"
                  />
                </Col> */}
                <Col span={8}>
                  <Select
                    name="leaveTypeId"
                    label={t('leave_type.label.leave_type')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={leaveGroupOptions.map(option => ({ value: option.value, label: option.label }))}
                  // onChange={handleLeaveTypeChange}
                  />
                </Col>
                <Col span={8}>
                  <Flex vertical style={{ gap: "8px" }}>
                    <label>{t('leave_type.label.leave_date')}</label>
                    <RangePicker
                      name="leaveDate"
                      placeholder={t('please-select-1')}
                      size="large"
                      ref={leaveDatePickerRef}
                      onChange={(dates) => {
                        setFieldValue('leaveDate', dates);
                      }}
                      value={values.leaveDate}
                    />
                  </Flex>
                </Col>
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>
              </Row>
            )}
            {dataFlag == "OFFSITE_WORK" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="reqId"
                    label={t('workin_location.label.reqid')}
                    placeholder={t('workin_location.label.reqid')}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="workTypeId"
                    label={t('my_request.label.work-type')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={OffSiteOptions}
                  />
                </Col>
                <Col span={8}>
                  <Flex vertical style={{ gap: "8px" }}>
                    <label>{t('leave_type.label.startDatetoEndDate')}</label>
                    <RangePicker
                      name="workDate"
                      placeholder={t('please-select-1')}
                      size="large"
                      // ref={leaveDatePickerRef}
                      onChange={(dates) => {
                        setFieldValue('workDate', dates);
                      }}
                      value={values.leaveDate}
                    />
                  </Flex>
                </Col>
                {/* <Col span={8}>
                  <DatePicker
                    name="startDate"
                    label="Start Offsite Work Date *"
                    placeholder="DD / MM / YYYY *"
                    size="large"
                    format={formatDate()}
                  />
                </Col> */}

                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "REDEEM_TIME" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                  <DatePicker
                    name="redeemDate"
                    label={t('my_request.label.date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                {/* <Col span={12}>
                  <TimePicker
                    name="startTime"
                    label="Start Time"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={startTime}
                  />
                </Col>
                <Col span={12}>
                  <TimePicker
                    name="endTime"
                    label="End Time"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={endTime}
                  />
                </Col> */}
                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag === "ENDORSE_TIME" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="reqId"
                    label={t('workin_location.label.reqid')}
                    placeholder={t('workin_location.label.reqid')}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Flex vertical style={{ gap: "8px" }}>
                    <label>{t('leave_type.label.startDatetoEndDate')}</label>
                    <RangePicker
                      name="endorseMentDate"
                      placeholder={t('please-select-1')}
                      size="large"
                      // ref={leaveDatePickerRef}
                      onChange={(dates) => {
                        setFieldValue('endorseMentDate', dates);
                      }}
                      value={values.leaveDate}
                    />
                  </Flex>
                </Col>


                {/* <Col span={12}>
                  <TimePicker
                    name="startTime"
                    label="Start Time"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={startTime}
                  />
                </Col>
                <Col span={12}>
                  <TimePicker
                    name="endTime"
                    label="End Time"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={endTime}
                  />
                </Col> */}
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "OVERTIME" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="reqId"
                    label={t('workin_location.label.reqid')}
                    placeholder={t('workin_location.label.reqid')}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Flex vertical style={{ gap: "8px" }}>
                    <label>{t('my_request.label.overtime-date')}</label>
                    <RangePicker
                      name="overtimeDate"
                      placeholder={t('please-select-1')}
                      size="large"
                      ref={overtimeDatePickerRef}
                      onChange={(dates) => {
                        setFieldValue('overtimeDate', dates);
                        console.log("dates", dates);
                      }}
                      value={values.overtimeDate}
                    />
                  </Flex>
                </Col>

                {/* <Col span={12}>
                  <Input
                    name="name"
                    label={t('employee.label.employee-name')}
                    placeholder={t('employee.label.employee-name')}
                    size="large"
                  />
                </Col> */}
                {/* <Col span={12}>
                  <DatePicker
                    name="startDate"
                    label={t('overtime-start-date')}
                    placeholder={t('common.placeholder.ddmmyyyy')}
                    size="large"
                    format={formatDate()}
                  />
                </Col>
                <Col span={12}>
                  <DatePicker
                    name="endDate"
                    label={t('overtime-end-date')}
                    placeholder={t('common.placeholder.ddmmyyyy')}
                    size="large"
                    format={formatDate()}
                  />
                </Col> */}
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-0')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>
              </Row>
            )}
            {dataFlag == "COLLECT_TIME" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                  <DatePicker
                    name="collectDate"
                    label={t('my_request.label.date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                {/* <Col span={12}>
                  <TimePicker
                    name="startTime"
                    label="Start Time *"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={startTime}

                  />
                </Col>
                <Col span={12}>
                  <TimePicker
                    name="endTime"
                    label="End Time *"
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                    value={endTime}

                  />
                </Col> */}
                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "DOCUMENT_REQUEST" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                  <Select
                    name="documentTypeId"
                    label={t('my_request.label.document-form-type')}
                    placeholder={t('common.pleaseSelect')}
                    size="large"
                    options={documentTypeOptions}
                  />
                </Col>
                <Col span={12}>
                  <DatePicker
                    name="preferredDate"
                    label={t('my_request.label.preferred-date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                <Col span={12}>
                  <DatePicker
                    name="submissionDate"
                    label={t('my_request.label.submission-date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>
                <Col span={12}>
                  <RadioGroup
                    name="receivingMethod"
                    label={t('my_request.label.receiving-method')}
                    options={[
                      {
                        label: t('my_request.label.app'),
                        value: "app",
                      },
                      {
                        label: t('employee.label.email'),
                        value: "email",
                      },
                      {
                        label: t('my_request.label.self-service-after-approval'),
                        value: "self_service",
                      },
                    ]}
                  />
                </Col>
                <Col span={12}>
                  <RadioGroup
                    name="languageFormat"
                    label={t('my_request.label.language-format')}
                    options={[
                      {
                        label: t('my_request.label.both'),
                        value: "both",
                      },
                      {
                        label: t('thai'),
                        value: "th",
                      },
                      {
                        label: t('english'),
                        value: "en",
                      },
                    ]}
                  />
                </Col>


              </Row>
            )}
            {dataFlag == "CHANGE_SHIFT" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Select
                    name="shiftType"
                    label={t('shift.label.shift_type')}
                    placeholder={t('shift.label.shift_type')}
                    size="large"
                    options={shiftTypeOptions.map((option => ({ value: option.value, label: option.key })))}
                  />
                </Col>
                <Col span={8}>
                  <DatePicker
                    name="startDate"
                    label={t('holiday.label.start_date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "WARNING_LETTER" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                  <Input
                    name="sequence"
                    size="large"
                    label={t("expense.expense-detail.request-id")}
                    placeholder={t("common.please_fill")}
                    allowClear
                  />
                </Col>
                <Col span={12}>
                  <Input
                    name="warnedEmployeeName"
                    label={t('warning_letter.label.employee')}
                    placeholder={t('common.please_fill')}
                    size="large"
                    allowClear
                  />
                </Col>
                {/* <Col span={8}>
                  <Input
                    name="department"
                    label="Department"
                    placeholder="Department"
                    size="large"
                  />
                </Col> */}
                <Col span={12}>
                  <DatePicker
                    name="incidentDate"
                    label={t('my_request.label.incident-date')}
                    placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                    size="large"
                  />
                </Col>
                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>
              </Row>
            )}

            {dataFlag == "EXPENSE" && (
              <Row gutter={24} style={{ marginLeft: "0px" }} className={styles.filter}>
                <Col span={8}>
                  <Input
                    name="sequence"
                    label={t("expense.expense-detail.request-id")}
                    placeholder={t("common.please_fill")}
                    allowClear
                  />
                </Col>

                <Col span={8}>
                  <Select
                    name="welfareSubCategoryType"
                    label={t('expense.header')}
                    placeholder={t('common.pleaseSelect')}
                    allowClear
                    options={dropdownWelfareSubTypeByCode}
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="approveStatusEn"
                    label={t('translation.status')}
                    placeholder={t('common.pleaseSelect')}
                    options={[
                      { value: 'Draft', label: t("approve-status.draft") },
                      { value: 'Pending', label: t("approve-status.pending") },
                      { value: 'Approved', label: t("approve-status.approve") },
                      { value: 'Rejected', label: t("approve-status.reject") },
                    ]}
                    allowClear
                  />
                </Col>
              </Row>
            )}


            <Row justify="end">
              <Space size={12} className={styles.filterbtn}>
                <Button type="default" onClick={resetForm} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}>
                  {t('cancel-1').toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>

          </Form>
        );
      }}
    </Formik>
  );
};

export default MyRequestFilter;
